import {connect} from "react-redux";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {WithObjectComponentHOC} from "../../../HOC/WithObjectComponentHOC";
import {WithAppendHeaderAndFooterHOC} from "../../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../../HOC/WithAppendSidebarHOC";
import PriceTableController from "./PriceTableControler";
import {WithSavingSnackBar} from "../../../HOC/WithSavingSnackBar";


let mapStateToProps =  (state) => {
    return {
        headerSubtitle: true,
        paymentType: state.object.payment_type,
        rooms: state?.object?.rooms
    }
};

let mapDispatchToProps =  (dispatch) => {
    return {
    }
};


export default compose(connect(mapStateToProps, {
    mapDispatchToProps,
}), withRouter, WithObjectComponentHOC, WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithSavingSnackBar)(PriceTableController);



